import 'select2';
import 'select2/dist/css/select2.css';
import './../../stylesheets/select2';

// 適応
export function apply (options = { 'disabled': false }) {
  $('select.select2').select2({
    placeholder: '選択してください。',
    allowClear: true,
    disabled: options['disabled'],
    language: { 
      "noResults": function(){
        return "該当する選択肢が見つかりません。";
      }
    },
    escapeMarkup: function (markup) {
      return markup;
    }
  })
}

// fields_forの_destroyを操作するアクション
export function fieldForDestroyFlgChangeAction () {
  $('select.select2').on('change', function (event) {
    let target = event.target.parentElement.querySelector('input[type="hidden"]', 'name&="[_destroy]"');
    if (!!target) {
      if (!!this.value) {
        target.value = 'false';
      } else {
        target.value = 'true';
      }
    }
  });
}

// 引数で受け取った要素のvalueに選択されたtextを埋め込む
export function setSelectedText (target) {
  $('select.select2').on('select2:select', function (event) {
    if (!!target) {
      if (!!this.value) {
        target.value = this.querySelector('option[value="' + this.value + '"]').text;
      }
    }
  });
}